import { render, staticRenderFns } from "./CadastrarAvaliacaoFormacaoDialog.vue?vue&type=template&id=35f9d772"
import script from "./CadastrarAvaliacaoFormacaoDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarAvaliacaoFormacaoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports